import React from 'react';
import { KpeLayout } from '../../../_shared/components/KpeLayout/KpeLayout';
import { mockLastActions } from '../../../_shared/mocks';
import { useKpeSelector } from '../../../_shared/store/store';
import { PlanningHeader } from '../../components/PlanningHeader/PlanningHeader';
import { EmployeeView } from '../../views/EmployeeView/EmployeeView';
import { ManagerView } from '../../views/ManagerView/ManagerView';
import { HrApprovalView } from '../../views/HrApprovalView/HrApprovalView';
import { LastActions } from '../../components/LastActions/LastActions';
import styles from './PlanningPage.module.scss';

function PlanningContent() {
  const role = useKpeSelector((s) => s.kpe.role);

  return (
    <div className={styles.page}>
      <PlanningHeader
        year={2027}
        status="Планирование КПЭ"
        startDate="1 марта 2027"
        fillDeadline="15 марта"
        approvalDeadline="до 25 марта"
        onReportClick={role === 'АС' ? () => {} : undefined}
      />
      {role === 'ВР' && <ManagerView />}
      {role === 'АС' && <HrApprovalView />}
      {role === 'Р' && <EmployeeView />}
      <div className={styles.lastActions}>
        <LastActions actions={mockLastActions} />
      </div>
    </div>
  );
}

export function PlanningPage() {
  return (
    <KpeLayout>
      <PlanningContent />
    </KpeLayout>
  );
}
